const customsgood = {
    getlist: 'customsgood/getlist',
    add: 'customsgood/add',
    update: 'customsgood/update',
    remove: 'customsgood/remove',
    get: 'customsgood/get',
    getall: 'customsgood/getall-by-admin',
    clearcache: 'customsgood/clear-cache',
}
export default customsgood
